/**
 * Derive avatar initials for the current user.
 *
 * No photo/avatar URL exists in the user model, so the header avatar renders
 * initials: the first letters of up to two name words, else the first letter of
 * the email, else '?'. Pure + exported so it can be unit-tested and reused.
 */
export function userInitials(user?: { name?: string; email?: string } | null): string {
  const name = user?.name?.trim();
  if (name) {
    const initials = name
      .split(/\s+/)
      .slice(0, 2)
      .map(w => w[0]?.toUpperCase() ?? '')
      .join('');
    if (initials) return initials;
  }
  const email = user?.email;
  return email ? email[0].toUpperCase() : '?';
}
